(function (w) {
  'use strict';

  var young = [
    'Olivia S.','Charlotte M.','Amelia B.','Mia C.','Isla K.','Ava H.','Grace T.','Chloe R.','Sophie P.','Emily D.',
    'Ella G.','Ruby L.','Zoe N.','Lucy W.','Hannah J.','Georgia F.','Tahlia A.','Madison V.','Jessica E.','Jasmine O.',
    'Sarah S.','Brooke M.','Lauren B.','Phoebe C.','Natalie K.','Abigail H.','Stephanie T.','Brianna R.','Megan P.','Caitlin D.',
    'Monique G.','Bianca L.','Sienna N.','Matilda W.','Imogen J.','Lily F.','Evie A.','Ashleigh V.','Courtney E.','Rebecca O.',
    'Chelsea S.','Hayley M.','Erin B.','Nicole C.','Kiara K.','Anika H.','Priya T.','Aisha R.','Mei P.','Sofia D.',
    'Elena G.','Giulia L.','Isabella N.','Nadia W.','Leah J.','Maya F.','Kira A.','Jade V.','Taylor E.','Alexandra O.'
  ];

  var mid = [
    'Amanda R.','Melissa P.','Michelle D.','Rachel G.','Rebecca L.','Kylie N.','Vanessa W.','Angela J.','Kristy F.','Fiona A.',
    'Joanne V.','Natalie E.','Nicole O.','Danielle S.','Belinda M.','Caroline B.','Louise C.','Kate K.','Kathryn H.','Emma T.',
    'Samantha R.','Jacqueline P.','Tanya D.','Leanne G.','Renee L.','Simone N.','Alison W.','Claire J.','Tamara F.','Tara A.',
    'Narelle V.','Melanie E.','Kristen O.','Andrea S.','Monica M.','Teresa B.','Maria C.','Anna K.','Elena H.','Francesca T.',
    'Diana R.','Helen P.','Sonia D.','Priya G.','Deepa L.','Anjali N.','Meena W.','Farah J.','Nadia F.','Layla A.',
    'Jenny V.','Linda E.','Cindy O.','Grace S.','Yuki M.','Mei B.','Jing C.','Rosa K.','Gabriella H.','Marina T.'
  ];

  var mature = [
    'Susan W.','Karen J.','Julie F.','Sharon A.','Deborah V.','Michelle E.','Christine O.','Wendy S.','Jennifer M.','Helen B.',
    'Janet C.','Robyn K.','Sandra H.','Carolyn T.','Donna R.','Diane P.','Lynette D.','Tracey G.','Cheryl L.','Kim N.',
    'Pamela W.','Denise J.','Anne F.','Margaret A.','Elizabeth V.','Patricia E.','Barbara O.','Catherine S.','Lorraine M.','Janine B.',
    'Judith C.','Suzanne K.','Gail H.','Maureen T.','Yvonne R.','Vicki P.','Kerry D.','Roslyn G.','Glenda L.','Marilyn N.',
    'Teresa W.','Maria J.','Angela F.','Rita A.','Franca V.','Carmela E.','Giovanna O.','Helen S.','Eleni M.','Despina B.',
    'Fatima C.','Farida K.','Amina H.','Mei T.','Li R.','Jenny P.','Sunita D.','Rekha G.','Anita L.','Rosemary N.'
  ];

  var all = young.concat(mid, mature);

  function norm(i, size) {
    i = parseInt(i, 10) || 0;
    return ((i % size) + size) % size;
  }

  function get(pool, index) {
    var i = norm(index, 60);
    if (pool === 'heels') return mid[i];
    if (pool === 'sandals') return mature[i];
    if (pool === 'dresses_sets') return all[60 + ((i * 2) % 120)];
    return all[(i * 3) % 180];
  }

  w.CRReviewNameBankAU = {
    market: 'Australia',
    syntheticTestingBank: true,
    young: young,
    mid: mid,
    mature: mature,
    all: all,
    get: get
  };
})(window);
